import { DefaultAbilityAction } from '@core/shared/ability';
import { ACCESS_SERVICE_PLUGIN_TOKEN } from '@core/shared/access';
import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MembershipBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/membership/feature","featureId":"common-membership"},
      bundledItemModels: ["MembershipItem", "MembershipReportItem", "MembershipRegistrationItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users', 'common-mail'],
      abilityActions: [{
        action: DefaultAbilityAction.View,
        defaultBias: -1
      }, {
        action: DefaultAbilityAction.Manage,
        defaultBias: -1
      }, {
        action: 'MembershipActive',
        defaultBias: -1,
        programmatic: true
      }, {
        action: 'MembershipExpired',
        defaultBias: -1,
        programmatic: true
      }, {
        action: 'MembershipNone',
        defaultBias: -1,
        programmatic: true
      }],
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MembershipFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MembershipFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'MembershipBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MembershipBackendAdminFeature'
      }],
      providers: [{
        forPlatform: 'frontend',
        token: ACCESS_SERVICE_PLUGIN_TOKEN,
        providerName: 'AccessMembershipFrontendPlugin',
        importFrom: 'frontend'
      }, {
        forPlatform: 'backend',
        token: ACCESS_SERVICE_PLUGIN_TOKEN,
        providerName: 'AccessMembershipBackendPlugin',
        importFrom: 'backend'
      }]
    };
  }
  getSharedDefinition() {
    const membershipRegistrationLinkResolver = (data = {}) => {
      let link = '/membership/registration';
      if (data?.referrerCode) link += '?referrerCode=' + data.referrerCode; /*URL_PARAM_REFERRER_CODE*/
      return link;
    };
    return {
      routerLinkResolvers: {
        frontend: {
          'membership-registration': membershipRegistrationLinkResolver
        }
      },
      virtualProperties: {
        'UserItem': [{
          name: 'phone',
          canRead: ['self', 'admin'],
          canEdit: ['self', 'admin']
        }, {
          name: 'allow3rdPartyContact',
          type: 'boolean',
          canRead: ['self', 'admin'],
          canEdit: ['self', 'admin']
        }]
      }
    };
  }
}